import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'datasources-dialog.progress-bar.cancel_connection': {
    id: 'datasources-dialog.progress-bar.cancel_connection',
    defaultMessage: 'Cancel connection',
    description:
      'The call to action that will cancel datasources connection import by forcing a tab reload when the user clicks on it.'
  },
  'datasources-dialog.progress-bar.connection_began': {
    id: 'datasources-dialog.progress-bar.connection_began',
    defaultMessage: 'Currently connecting. Keep this tab open until finished.',
    description:
      'The text message displayed when datasources import is beginning to import issues. It warns the user that closing the tab will abort the process.'
  },
  'datasources-dialog.progress-bar.connection_with_count': {
    id: 'datasources-dialog.progress-bar.connection_with_count',
    defaultMessage:
      'Currently connecting {currentCount}/{totalCount}... Keep this tab open until finished.',
    description:
      'The text message displayed when datasources import is creating new entries with the knowledge of how many entries there will be. It warns the user that closing the tab will abort the process.'
  },
  'datasources-dialog.progress-bar.connection_complete': {
    id: 'datasources-dialog.progress-bar.connection_complete',
    defaultMessage: 'Successfully connected {connectionType}',
    description:
      'The text message displayed when datasources connection import is complete.'
  },
  'connections.field.title.version-comment': {
    id: 'connections.field.version-comment',
    defaultMessage: 'Version Comment',
    description: 'The title of the field that stores the version comment.'
  },
  'connections.field.title.excerpt': {
    id: 'connections.field.excerpt',
    defaultMessage: 'Excerpt',
    description: 'The title of the field that stores the excerpt.'
  },
  'connections.field.title.page_status': {
    id: 'connections.field.page_status',
    defaultMessage: 'Status',
    description: 'The title of the field that stores the page status.'
  }
});
